'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.secondsSince;


// WEBPACK FOOTER //
// ./~/sugar-date/date/secondsSince.js